import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../store/ApplicationState";
import { getExchangedToken, getRefreshedToken } from "../../actions/Sso";
import { getUserModule } from "../../actions/Modules";
import AppContent from "../components/AppContent";
import { ExchangeCodePayload } from "../../models/Sso";
import { SSO_ActionTypes } from "../../models/DispatchTypes/Sso";
import { ModulesDispatchTypes } from "../../models/DispatchTypes/Modules";
import { LogoutOfApp } from "../../actions/Logout";

const mapStateToProps = ({
  exchangedTokenState,
  refreshedTokenState,
  logoutState,
}: ApplicationState) => ({
  exchangedTokenState: exchangedTokenState.response,
  exchangedTokenLoading: exchangedTokenState.loading,
  refreshedTokenState: getRefreshTokenResponse(refreshedTokenState),
  logoutResp: logoutState,
});

const getRefreshTokenResponse = (refreshedTokenState: any) => {
  return refreshedTokenState.response
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, SSO_ActionTypes | ModulesDispatchTypes>
) => {
  return {
    getExchangedToken: (payload: ExchangeCodePayload) => {
      dispatch(getExchangedToken(payload));
    },
    getRefreshedToken: (payload: any) => {
      dispatch(getRefreshedToken(payload));
    },
    logoutOfApp: () => {
      dispatch(LogoutOfApp());
    },
    getUserModules: () => {
      dispatch(getUserModule());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContent);
